import { XMarkIcon } from '@heroicons/react/24/outline'
import type { RemoveBoxButtonProps } from './types'

export function RemoveBoxButton({ onClick, disabled }: RemoveBoxButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid="remove-box-button"
      className="p-1 rounded hover:bg-gray-700/50 disabled:opacity-50 disabled:cursor-not-allowed
                 transition-colors duration-200"
      aria-label="Remove this box"
    >
      <XMarkIcon className="w-5 h-5" />
    </button>
  )
}
